export const SWAG_BATCHES_BREAKDOWN_DATA_REQUEST = 'SWAG_BATCHES_BREAKDOWN_DATA_REQUEST';
export const SWAG_BATCHES_BREAKDOWN_DATA_SUCCESS = 'SWAG_BATCHES_BREAKDOWN_DATA_SUCCESS';
export const SWAG_BATCHES_BREAKDOWN_DATA_FAIL = 'SWAG_BATCHES_BREAKDOWN_DATA_FAIL';
export const SWAG_BATCHES_BREAKDOWN_CLEAR = 'SWAG_BATCHES_BREAKDOWN_CLEAR';

export const SWAG_BATCHES_DOWNLOAD_REPORT_LINK = 'SWAG_BATCHES_DOWNLOAD_REPORT_LINK';
